import React from 'react'
import { SiMicrosoftexcel } from 'react-icons/si'

/** Botón de ícono Excel para descargar los casos de un indicador (RG-602). */
const BotonExportar = ({ onClick, disabled = false, titulo = 'Descargar los casos en Excel', size = 16, style }) => (
    <button
        type='button'
        className='btn btn-link p-0 border-0'
        title={titulo}
        aria-label={titulo}
        disabled={disabled}
        onClick={onClick}
        style={{ color: '#1D6F42', lineHeight: 1, ...style }}
    >
        <SiMicrosoftexcel size={size} />
    </button>
)

export default BotonExportar
